import { useContext, useEffect, useMemo } from "react";
import { BehaviorSubject } from 'rxjs';
import DruidWebchatContext, { DruidWebchatContextType } from '../WebChatContext';


export const useDebounceHideSuggestedActions = (outerBFSuggestedActions: any[]) => {

    const [, druidWebChatDispatch, ,] = useContext<DruidWebchatContextType>(DruidWebchatContext);

    const debounceHideSuggestedActions = useMemo(() => {
        const behaviorSubject = new BehaviorSubject(false);
        behaviorSubject.debounceTime(50).distinctUntilChanged().subscribe(hide => {
            if(outerBFSuggestedActions.length) {
                druidWebChatDispatch({ type: 'HIDE_SUGGESTEDACTIONS', payload: hide });
            }
        });
        return behaviorSubject;
    }, [outerBFSuggestedActions]);
    useEffect(() => {
        return () => {
            debounceHideSuggestedActions && debounceHideSuggestedActions.complete();
        }
    }, [outerBFSuggestedActions]);

    return debounceHideSuggestedActions;
}

// removed from WebChat.tsx
// const debounceHideSuggestedActions = useMemo(() => {
  //   const behaviorSubject = new BehaviorSubject(false);
  //   behaviorSubject.debounceTime(50).distinctUntilChanged().subscribe(hide => {
  //     druidWebChatDispatch({ type: 'HIDE_SUGGESTEDACTIONS', payload: hide })
  //   });
  //   return behaviorSubject;
  // }, []);
  // useEffect(() => {
  //   return () => {
  //     debounceHideSuggestedActions && debounceHideSuggestedActions.complete();
  //   }
  // }, []);

  // // useEffect(() => {
  // //   debounceHideSuggestedActions.next(!outerBFatEnd);
  // // }, [outerBFatEnd]);